import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/** Global admin search across customers, partners, memberships, bookings and SOS. */
const searchService = {
  search: async (q, limit = 5) => {
    const response = await apiClient.post(API_ENDPOINTS.SEARCH.GLOBAL, { q, limit });
    const body = response.data;
    if (!body || body.IsSuccess === false) throw new Error((body && body.Message) || 'Search failed');
    return body.Data;
  },
};

export default searchService;
